import { ButtonActionSubtle } from '@honeycomb-npm/honeycomb-react';
import styled from 'styled-components';

// Wraps the Honeycomb ButtonActionSubtle in some styling to make it right-aligned and smaller
// The right aligned button included in Honeycomb uses float-right for alignment which is awkward to use
// This wrapper is intended for grid layout instead
// It also removes the margin and reduces the minimum width so that it doesn't take up so much space
const RightAlignedButton = styled(ButtonActionSubtle)`
    &&& {
        justify-self: end;
        justify-content: center;
        margin-right: 0;
        margin-bottom: 0;
        min-width: 2rem;
        max-width: 100%;
        max-height: 1.5rem;
    }
`;

export default RightAlignedButton;
